export default function SkeletonLoader({ type = 'list', count = 3 }) {
  if (type === 'card') {
    return (
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="skeleton" style={{ height: 120 }} />
        ))}
      </div>
    );
  }

  if (type === 'page') {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        <div className="skeleton" style={{ height: 32, width: '40%' }} />
        <div className="skeleton" style={{ height: 16, width: '100%' }} />
        <div className="skeleton" style={{ height: 16, width: '80%' }} />
      </div>
    );
  }

  // type === 'list'
  return (
    <div>
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="skeleton"
          style={{ height: 56, marginBottom: 0, borderRadius: 0, borderBottom: '1px solid rgb(var(--border))' }}
        />
      ))}
    </div>
  );
}
